import React, { useState, useEffect } from "react";

import { Label, Spinner } from "reactstrap";
import { convertToRaw, ContentState, EditorState } from "draft-js";

import { Editor } from "react-draft-wysiwyg";
import { Controller } from "react-hook-form";

import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import { LabelInput } from "../TextField";

import "@styles/react/libs/editor/editor.scss";

import * as S from "../TextField/styles";

const EditorComponent = ({
  field,
  name,
  label,
  required,
  error,
  isLoading,
  helperText,
  ...props
}) => {
  const [editorState, setEditorState] = useState(() => {
    const blocksFromHtml = htmlToDraft(field?.value || "");
    const contentState = ContentState.createFromBlockArray(
      blocksFromHtml.contentBlocks,
      blocksFromHtml.entityMap,
    );
    return EditorState.createWithContent(contentState);
  });

  useEffect(() => {
    const currentContent = draftToHtml(
      convertToRaw(editorState.getCurrentContent()),
    );
    const fieldValue = field?.value || "";

    if (currentContent !== fieldValue) {
      const blocksFromHtml = htmlToDraft(fieldValue);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHtml.contentBlocks,
        blocksFromHtml.entityMap,
      );
      const newEditorState = EditorState.createWithContent(contentState);
      setEditorState(newEditorState);
    }
  }, [field?.value]);

  const handleEditorStateChange = newEditorState => {
    setEditorState(newEditorState);
    const htmlContent = draftToHtml(
      convertToRaw(newEditorState.getCurrentContent()),
    );
    field.onChange({
      target: {
        name,
        value: htmlContent,
      },
    });
  };

  return (
    <S.InputFieldContainer>
      {required ? (
        <LabelInput name={name} label={label} />
      ) : (
        <Label hidden={!label} error={!field?.value && error}>
          {label}
        </Label>
      )}
      <Editor
        name={name}
        editorState={editorState}
        onEditorStateChange={handleEditorStateChange}
        {...props}
      />
      {isLoading && (
        <S.Loading>
          <Spinner size="sm" />
        </S.Loading>
      )}
      <S.InputFieldHelperText error={!field?.value && error}>
        {helperText}
      </S.InputFieldHelperText>
    </S.InputFieldContainer>
  );
};

export const NewEditorText = ({
  name,
  control,
  label,
  helperText,
  error,
  width,
  isLoading,
  required = false,
  ...props
}) =>
  control && (
    <Controller
      rules={{ required }}
      name={name}
      control={control}
      render={({ field }) => (
        <EditorComponent
          field={field}
          name={name}
          label={label}
          required={required}
          error={error}
          isLoading={isLoading}
          helperText={helperText}
          {...props}
        />
      )}
    />
  );
